export default __webpack_public_path__ + "static/media/drawer-close.27da0053.svg";